module.exports = __webpack_public_path__ + "img/subject-11.616da107.svg";